module.exports = __webpack_public_path__ + "img/product-four-0.c8689d4c.png";